import type { CSSObject } from '@emotion/react';
import styled from '@emotion/styled';
import type { Theme as LocalTheme } from '@trinity/chat-components/types/theme';

export const getCitationNumberStyles = (theme: Pick<LocalTheme.Theme, 'palette' | 'fonts'>): CSSObject => ({
  color: theme.palette.badge.citation.color,
  backgroundColor: theme.palette.badge.citation.bg,

  boxSizing: 'border-box',
  minHeight: 12,
  minWidth: 12,
  padding: 2,

  fontSize: 11,
  fontFamily: theme.fonts.bold,
  borderRadius: 3,

  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const CitationNumber = styled.div(({ theme }) => ({
  ...getCitationNumberStyles(theme),
}));